import { api } from "../../configs/api";
import { ROUTE } from "../../routes";
import { ButtonTypeTokens } from "@voltmoney/schema";
import SharedPropsService from "../../SharedPropsService";
import { getAppHeader, } from "../../configs/config";
import { clearAllData, getApplicationId, getDateMonthYearFromEpoch, getParameters, MfCentralFlow, nextStepCredStepper, nextStepId } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { phonePayRoutes } from "../../configs/utils";
import { Platform } from 'react-native';
import { LENDER_ID, QUERY_PARAMS } from "../../configs/constants";
export const fetchMyPortfolio = async (action, _datastore, { network, navigate, setDatastore, goBack, analytics, instrumentTrack, ...props }) => {
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    const utmSource = params?.utm_source;
    const applicationId = await getApplicationId();
    await setDatastore(action.routeId, "borrowerLandingPage", {
        label: "",
        type: ButtonTypeTokens.LargeOutline,
        loading: true,
    });
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const isFromBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE" /* AppPlatform.BHARAT_PE */;
    const isFromSecondBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE_2" /* AppPlatform.BHARAT_PE_2 */;
    let isFromTata = userContextResponse?.data?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.TATA;
    if (userContextResponse?.status === 200) {
        await setDatastore(action.routeId, 'borrowerLandingPage', {
            loading: false,
        });
        const currentStepId = userContextResponse.data.linkedApplications[0].currentStepId;
        if (currentStepId === "MF_FETCH_PORTFOLIO" || currentStepId === "MF_PLEDGE_PORTFOLIO") {
            const enabledRTAFlowResponse = await network.get(`${api.isFromMFCentralFlow}${applicationId}`, { headers: await getAppHeader() });
            if (enabledRTAFlowResponse?.status === 200) {
                const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === MfCentralFlow;
                const mfcFetchStatus = enabledRTAFlowResponse?.data?.mfcFetchStatus;
                if (userContextResponse?.data?.linkedBorrowerAccounts[0]?.accountHolderEmail === null) {
                    await navigate(ROUTE.ENTER_EMAIL);
                }
                else if (mfcFetchStatus === "IN_PROGRESS") {
                    await navigate(ROUTE.MFC_FETCH_EVALUTE_FUNDS);
                }
                else if (isFromMFCentral && currentStepId === ROUTE.MF_PLEDGE_PORTFOLIO) {
                    await navigate(ROUTE.MFC_FETCH_ANCHOR);
                }
                else if (isFromMFCentral && currentStepId === ROUTE.MF_FETCH_PORTFOLIO) {
                    await navigate(ROUTE.MF_FETCH_PORTFOLIO);
                }
                else if (!isFromMFCentral) {
                    const routeObj = await nextStepId(currentStepId);
                    await navigate(routeObj.routeId, routeObj.params);
                }
            }
        }
        else {
            const routeObj = await nextStepId(currentStepId);
            if (await SharedPropsService.getAppPlatform() === "FREO" /* AppPlatform.FREO */ && !phonePayRoutes.includes(routeObj.routeId) && utmSource !== QUERY_PARAMS.PHONE_PE_FJ) {
                await navigate(ROUTE.PHONE_PAY_PAGE);
            }
            else if (params?.plj && userContextResponse?.data?.linkedBorrowerAccounts[0]?.accountHolderEmail === null) {
                await navigate(ROUTE.ENTER_EMAIL);
            }
            else if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && !phonePayRoutes.includes(routeObj.routeId) && !isFromTata) {
                await navigate(ROUTE.PHONE_PAY_PAGE);
            }
            else if ((isFromBharatPe || isFromSecondBharatPe) && !phonePayRoutes.includes(routeObj.routeId)) {
                await navigate(ROUTE.PHONE_PAY_PAGE);
                return;
            }
            else {
                await navigate(routeObj.routeId, routeObj.params);
            }
        }
    }
    else
        await setDatastore(action.routeId, 'continue', {
            loading: false,
        });
};
export const logout = async (action, _datastore, { navigate, navigateToBase }) => {
    clearAllData().then(() => {
        navigateToBase(ROUTE.PHONE_NUMBER);
    });
};
export const continueAction = async (action, _datastore, { navigate }) => {
    const userData = await SharedPropsService.getUser();
    const currentStepId = userData.linkedApplications[0].currentStepId;
    const routeObj = await nextStepCredStepper(currentStepId);
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    const utmSource = params?.utm_source;
    console.warn("ROUTE OBJ RECEIVED IS", routeObj);
    const isFromTata = userData?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.TATA;
    const isFromDsp = userData?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.DSP;
    const isFromBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE" /* AppPlatform.BHARAT_PE */;
    const isFromSecondBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE_2" /* AppPlatform.BHARAT_PE_2 */;
    if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && !phonePayRoutes.includes(routeObj.routeId) && utmSource !== QUERY_PARAMS.PHONE_PE_FJ) {
        await navigate(ROUTE.PHONE_PAY_PAGE);
    }
    else if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && !phonePayRoutes.includes(routeObj.routeId) && (!isFromTata && !isFromDsp)) {
        await navigate(ROUTE.PHONE_PAY_PAGE);
    }
    else if ((isFromBharatPe || isFromSecondBharatPe) && !phonePayRoutes.includes(routeObj.routeId)) {
        await navigate(ROUTE.PHONE_PAY_PAGE);
        return;
    }
    else {
        await navigate(routeObj.routeId, routeObj.params);
    }
};
export const showShowEditLimit = async (action, _datastore, { network, setDatastore }) => {
    const shouldShowEditLimit = await SharedPropsService.showEnableLimit();
    await setDatastore(ROUTE.BORROWER_LANDING_SCREEN, "borrowerLandingPage", {
        showEditLimit: shouldShowEditLimit
    });
};
export const faqDetails = async (action, _datastore, { navigate }) => {
    await (navigate(ROUTE.FAQ, {
        title: action.payload.value
    }));
};
export const continueEditAction = async (action, _datastore, { network, navigateWithClear, navigate }) => {
    const userData = await SharedPropsService.getUser();
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    const utmSource = params?.utm_source;
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = userData.linkedApplications[0].applicationId;
    }
    const enabledRTAFlowResponse = await network.get(`${api.isFromMFCentralFlow}${applicationId}`, { headers: await getAppHeader() });
    const continueEditResponse = await network.get(`${api.editLimitRoute}${applicationId}`, {
        headers: await getAppHeader()
    });
    const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === MfCentralFlow;
    const isFromBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE" /* AppPlatform.BHARAT_PE */;
    const isFromSecondBharatPe = await SharedPropsService.getAppPlatform() === "BHARAT_PE_2" /* AppPlatform.BHARAT_PE_2 */;
    if (isFromMFCentral) {
        await navigateWithClear(ROUTE.MFC_FETCH_ANCHOR);
    }
    else {
        const currentStepId = continueEditResponse.data.updatedApplicationObj.currentStepId;
        const routeObj = await nextStepCredStepper(currentStepId);
        let isFromTata = userData?.linkedApplications[0].lenderAccountId.toLowerCase() === LENDER_ID.TATA;
        if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && !phonePayRoutes.includes(routeObj.routeId) && utmSource !== QUERY_PARAMS.PHONE_PE_FJ) {
            await navigate(ROUTE.PHONE_PAY_PAGE);
        }
        else if (await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */ && !phonePayRoutes.includes(routeObj.routeId) && !isFromTata) {
            await navigate(ROUTE.PHONE_PAY_PAGE);
        }
        else if ((isFromBharatPe || isFromSecondBharatPe) && !phonePayRoutes.includes(routeObj.routeId)) {
            await navigate(ROUTE.PHONE_PAY_PAGE);
            return;
        }
        else {
            await navigateWithClear(routeObj.routeId, routeObj.params);
        }
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const navigateToProfile = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.MY_PROFILE);
};
export const navigateToIc = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.INTEREST_CALCULATOR_APP);
};
export const onPageLoad = async (action, _datastore, { navigate, network, setDatastore }) => {
    await setDatastore(action.routeId, 'borrowerLandingPage', {
        onLoadComplete: false,
    });
    const user = await SharedPropsService.getUser();
    const pledgeLimitResponse = await SharedPropsService.getPledgeData();
    const stepResponseObject = pledgeLimitResponse?.data?.stepResponseObject;
    const repositoryAssetMetadataMap = pledgeLimitResponse?.data?.stepResponseObject?.repositoryAssetMetadataMap;
    const creditLimit = (stepResponseObject?.approvedCreditLimit || 0) + (stepResponseObject?.requestCreditLimit || 0);
    const camsDate = repositoryAssetMetadataMap?.CAMS.casFetchDate;
    const karvyDate = repositoryAssetMetadataMap?.KARVY.casFetchDate;
    const latestDate = Math.max(camsDate, karvyDate);
    const accountId = user.linkedApplications[0].accountId;
    let totalAmount = 0;
    if (stepResponseObject) {
        if (creditLimit != null && creditLimit > 0)
            totalAmount = creditLimit;
        else
            totalAmount = 0;
    }
    const isEditLimitEnabled = await SharedPropsService.showEnableLimit();
    // --------- CONFIG --------- //
    let showInterestCalculator;
    const platformCongig = await network.get(api.platformDetailsApi, {
        headers: await getAppHeader()
    });
    if (platformCongig?.status === 200) {
        showInterestCalculator = platformCongig?.data?.platformSDKConfig?.showInterestCalculator;
        await SharedPropsService.setShowInterestCalculator(showInterestCalculator);
    }
    const date = `${getDateMonthYearFromEpoch(latestDate)}`;
    // -------------------------- //
    setTimeout(async () => {
        await setDatastore(action.routeId, 'borrowerLandingPage', {
            onLoadComplete: true,
        });
    }, 1000);
};
